module.exports = __webpack_public_path__ + "img/1f965.34b5f70.svg";